import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 25474 15677"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#1c1b17;stroke-width:369.181}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970276457488">
        <path
          d="M4029 7838c0 564 457 1022 1021 1022s1021-458 1021-1022c0-563-457-1021-1021-1021s-1021 458-1021 1021zM7872 7838c0 564 457 1022 1021 1022s1022-458 1022-1022c0-563-458-1021-1022-1021-564 1-1021 458-1021 1021zM11716 7838c0 564 457 1022 1021 1022s1021-458 1021-1022c0-563-457-1021-1021-1021s-1021 458-1021 1021zM185 7838c0 564 457 1022 1020 1022 565 0 1022-458 1022-1022 0-563-457-1021-1022-1021-563 1-1020 458-1020 1021z"
          className="fill stroke1"
          style={{
            strokeWidth: 369.181,
          }}
        />
      </g>
      <g id="_1970276457264">
        <path
          d="M15560 1206c0 564 457 1021 1020 1021 564 0 1022-457 1022-1021s-457-1021-1022-1021c-563 0-1020 457-1020 1021zM15560 4522c0 564 457 1021 1020 1021 564 0 1022-457 1022-1021s-457-1021-1022-1021c-563 0-1020 457-1020 1021zM19403 4522c0 564 457 1021 1021 1021s1021-457 1021-1021-457-1021-1021-1021-1021 457-1021 1021zM15560 7838c0 564 457 1022 1020 1022 564 0 1022-458 1022-1022 0-563-457-1021-1022-1021-563 1-1020 458-1020 1021zM19403 7838c0 564 457 1022 1021 1022s1021-458 1021-1022c0-563-457-1021-1021-1021-564 1-1021 458-1021 1021zM23247 7838c0 564 457 1022 1021 1022s1021-458 1021-1022c0-563-457-1021-1021-1021-564 1-1021 458-1021 1021zM15560 11155c0 564 457 1022 1020 1022 564 0 1022-458 1022-1022s-457-1021-1022-1021c-563 0-1020 457-1020 1021zM19403 11155c0 564 457 1022 1021 1022s1021-458 1021-1022-457-1021-1021-1021-1021 457-1021 1021zM15560 14472c0 563 457 1020 1020 1020 564 0 1022-457 1022-1020 0-565-457-1022-1022-1022-563 0-1020 457-1020 1022z"
          className="fill stroke1"
          style={{
            strokeWidth: 369.181,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
